import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

function normalizeDev(msgObj) {
  let dev = msgObj?.dev;

  // if it's a JSON string like "[]", parse it
  if (typeof dev === "string") {
    try {
      dev = JSON.parse(dev);
    } catch {
      dev = [];
    }
  }

  // ensure it's an array
  if (!Array.isArray(dev)) dev = [];

  return { ...msgObj, dev: dev };
}

const ZbTableList = ({
    serial,
    data,
    mqttReq
}) => {
    const [zbListState, setZbListState] = useState({ "dev": [] });

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setZbListState(normalizeDev(data))
    }, [data]);

    function refreshzblist() {
        mqttReq(serial, '/zbmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'blue', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi ZB' : 'Mostra ZB'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_device" colSpan="5">ZB devices</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                                {zbListState?.time}
                            </th>
                        </tr>
                        <tr>
                            <th className="title">eui</th>
                            <th className="title">model identifier</th>
                            <th className="title">name</th>
                            <th className="title">online</th>
                            <th className="title">battery</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={refreshzblist}>aggiorna</button>
                            </th>
                        </tr>
                        {zbListState?.dev.map(mapZBdev => (
                            <tr key={mapZBdev.eui}>
                                <td>{mapZBdev.eui}</td>
                                <td>{mapZBdev.modelIdentifier}</td>
                                <td>{mapZBdev.name}</td>
                                <td>{mapZBdev.online}</td>
                                <td>{mapZBdev.battery}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ZbTableList;
